'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'face-awesome';
var width = 512;
var height = 512;
var aliases = ["gave-dandy"];
var unicode = 'e409';
var svgPathData = 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 224L80 224l0-32c0-30.9 25.1-56 56-56c.9 0 1.8 0 2.8 .1c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c12.8 0 23.8-7.5 28.9-18.3c2 5.7 3.1 11.9 3.1 18.3l0 32zM136 120c-39.8 0-72 32.2-72 72l0 32 0 16 16 0 112 0 16 0 0-16 0-32c0-39.8-32.2-72-72-72zm40 40a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm200 8a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-21.2-39.9c-6.6 5.9-10.8 14.4-10.8 23.9c0 17.7 14.3 32 32 32c15.1 0 27.8-10.5 31.1-24.5c5.6 9.5 8.9 20.7 8.9 32.5l0 32-128 0 0-32c0-35.3 28.7-64 64-64c.9 0 1.8 0 2.8 .1zM272 192l0 32 0 16 16 0 128 0 16 0 0-16 0-32c0-44.2-35.8-80-80-80s-80 35.8-80 80zm89.9 187.8C334.2 411.9 293.3 432 248 432c-2.1 0-4.3 0-6.4-.1c7.5-36.4 39.7-63.9 78.4-63.9c15.4 0 29.7 4.3 41.9 11.8zm12.8-10.7C359.2 358.3 340.4 352 320 352c-47 0-86.1 33.8-94.4 78.4C153.8 420.3 96.6 362.1 89.5 288l317 0c-2.9 30.5-14.3 58.3-31.7 81.1zM248 448c90.6 0 166.3-69.1 174.5-159.3l.1-.7 1.5-16-16.1 0L88.1 272 72 272l1.5 16 .1 .7C81.7 378.9 157.4 448 248 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceAwesome = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;